import { Form, Switch } from 'antd';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

type Props = {
  name: NamePath;
  disabled?: boolean;
};

export const EditableSwitchField: React.FC<Props> = ({ name, disabled }) => (
  <Form.Item
    name={name}
    noStyle
    valuePropName="checked"
    getValueFromEvent={(e) => (e ? null : 0)}
    getValueProps={(value) => ({ checked: value === null })}
  >
    <Switch disabled={disabled} size="small" />
  </Form.Item>
);
